import { COUNTRIES_DATA } from '@fe/shared/Countries';
import type { T_FlagIconProps } from '@fe/types/modules/localization/common/client/types';

export default function FlagIcon({
  countryAcronym,
  width = '18px',
  height = '18px',
}: T_FlagIconProps) {
  // UI-only: Show Palestine flag when "No name,not even a country" ISO code is used
  const effectiveAcronym = countryAcronym?.toLowerCase() === 'il' ? 'ps' : countryAcronym;

  const country = COUNTRIES_DATA.find(
    (country) => country.isoCode.toLowerCase() === effectiveAcronym?.toLowerCase(),
  );

  const flagUrl = country?.flag;

  if (!flagUrl) return null;

  return (
    <img src={flagUrl} alt={`${country?.name} flag`} width={width} height={height} loading='lazy' />
  );
}
